












export default {
  name: 'ProductDetailsLink',
  props: {
    link: {
      type: String,
      require: true,
    },
  },
}
